import React, { memo } from 'react';
import { string, oneOfType, number, bool } from 'prop-types';
import Button from 'components/Button';
import { ReactComponent as JavelinLogo } from 'assets/icons/logo-javelin.svg';
import { productNew as TEXT } from 'locales/en';
import { priceToDisplay } from 'utils/price';

const Preview = ({ image, name, description, price, fitPhoto }) => {
  return (
    <div className="relative mx-auto w-80 h-128 mt-8 rounded-xl shadow-2xl bg-white border-gray-50 border overflow-hidden">
      <div
        data-testid="image"
        className="w-full h-52 overflow-hidden rounded-t-xl"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: fitPhoto ? 'cover' : 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
      <hr className="horizontal-line mb-8 absolute left-0" />
      <div className="mt-8 text-center">
        <h1
          className={`block h-7 mx-2 overflow-hidden text-javelin-gray-dark text-lg font-bold tracking-wide ${
            !name
              ? 'bg-gray-100 w-60 rounded transition duration-300 mx-auto'
              : ''
          }`}
          data-testid="name"
        >
          {name}
        </h1>
        <h2
          className={`block h-10 m-2 overflow-hidden text-javelin-gray-dark text-sm tracking-wide ${
            !description
              ? 'bg-gray-100 w-auto rounded transition duration-300 mx-4 box-border'
              : 'h-4'
          }`}
          data-testid="description"
        >
          {description}
        </h2>
        <h4
          className={`text-javelin-gray-dark text-3xl font-bold tracking-wider lg:mt-5 ${
            !price
              ? 'bg-gray-100 w-auto rounded h-9 transition duration-300 mx-10 box-border'
              : ''
          }`}
          data-testid="price"
        >
          {`€${priceToDisplay(price)}`}
        </h4>
        <span
          className="absolute flex items-center justify-between px-2 lg:px-6 left-0 bottom-0 w-full bg-javelin-babyBlue h-28 rounded-b-xl"
          data-testid="footer"
        >
          <span>
            <p className="text-javelin-gray-dark text-tiny">Powered by</p>
            <JavelinLogo className="fill-current text-javelin-gray w-10 mx-auto lg:w-12" />
          </span>
          <Button
            className="w-28 p-4 text-base btn-blue hover:opacity-100 cursor-default text-white float-right"
            title={TEXT.buyNow}
            disabled
          />
        </span>
      </div>
    </div>
  );
};

Preview.propTypes = {
  image: string,
  name: string,
  description: string,
  price: oneOfType([string, number]),
  fitPhoto: bool,
};
Preview.defaultProps = {
  image: '',
  name: '',
  description: '',
  price: 0,
  fitPhoto: false,
};

export default memo(Preview);
